export const name = "RANGE_INTERSECT";
export const summary = `Gets a segment of two ranges that intersect.`;
export const reference = `
## RANGE_INTERSECT

Gets a segment of two ranges that intersect.

\`\`\`
RANGE_INTERSECT(range_a, range_b)
\`\`\`

### Description

Gets a segment of two ranges that intersect.


### Definitions

- \`range_a\`: The first \`RANGE<T>\` value.
- \`range_b\`: The second \`RANGE<T>\` value.


### Details

Returns \`NULL\` if any input is\`NULL\`.

Produces an error if \`range_a\` and \`range_b\` don't overlap. To return\`NULL\` instead, add the \`SAFE.\` prefix to the function name.

\`T\` must be of the same type for all inputs.


### Return type

\`RANGE<T>\`


### Examples



\`\`\`
SELECT RANGE_INTERSECT(
  RANGE<DATE> '[2022-02-01, 2022-09-01)',
  RANGE<DATE> '[2021-06-15, 2022-04-15)') AS results;

/*--------------------------+
 | results |
 +--------------------------+
 | [2022-02-01, 2022-04-15) |
 +--------------------------*/
\`\`\`



\`\`\`
SELECT RANGE_INTERSECT(
  RANGE<DATE> '[2022-02-01, UNBOUNDED)',
  RANGE<DATE> '[2021-06-15, 2022-04-15)') AS results;

/*--------------------------+
 | results |
 +--------------------------+
 | [2022-02-01, 2022-04-15) |
 +--------------------------*/
\`\`\`



\`\`\`
SELECT RANGE_INTERSECT(
  RANGE<DATE> '[2022-02-01, UNBOUNDED)',
  RANGE<DATE> '[2021-06-15, UNBOUNDED)') AS results;

/*-------------------------+
 | results |
 +-------------------------+
 | [2022-02-01, UNBOUNDED) |
 +-------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/range-functions
`;
